<template>
  <form novalidate class="formluar max-width" @submit.prevent="submit">
    <b-form-group class="control-select" :state="!$v.form.amountType.$error" :label="$t('views.vouchers.discounts.form.amounttype')">
      <b-input-group>
        <div class="control-wrapper">
          <b-select v-model="form.amountType" :state="!$v.form.amountType.$error" :options="getAmountTypesOptions()"/>
        </div>
      </b-input-group>
      <b-form-invalid-feedback :state="!$v.form.amountType.$error">{{ $t('components.controls.feedbacks.invalid.required') }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="showAmountTypeInput('Percent')" :state="!$v.form.percent.$error" :label="$t('views.vouchers.discounts.form.percent')">
      <b-input-group>
        <div class="control-wrapper">
          <b-input type="number" v-model="form.percent" :state="!$v.form.percent.$error"/>
        </div>
        <div class="input-group-append">
          <span class="input-group-text">%</span>
        </div>
      </b-input-group>
      <b-form-invalid-feedback :state="!$v.form.percent.$error">{{ $t('components.controls.feedbacks.invalid.required') }}</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group v-if="showAmountTypeInput('Amount')" :state="!$v.form.amount.$error" :label="$t('views.vouchers.discounts.form.amount')">
      <b-input-group>
        <div class="control-wrapper">
          <b-input type="number" v-model="form.amount" :state="!$v.form.amount.$error"/>
        </div>
        <div class="input-group-append">
          <span class="input-group-text">CHF</span>
        </div>
      </b-input-group>
      <b-form-invalid-feedback :state="!$v.form.amount.$error">{{ $t('components.controls.feedbacks.invalid.required') }}</b-form-invalid-feedback>
    </b-form-group>
    <div class="form-actions">
      <div class="justify-content-end">
        <b-button @click="cancel" class="me-1"><b-icon icon="abort"/>{{$t('views.vouchers.discounts.form.cancel')}}</b-button>
        <b-button type="submit" variant="primary"><b-icon icon="send"/>{{$t('views.vouchers.discounts.form.save')}}</b-button>
      </div>
    </div>
  </form>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators'

const AmountTypes = ['Percent', 'Amount']
export default {
  name: 'DiscountForm',
  props: {
    discount: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        amountType: ''
      }
    }
  },
  validations () {
    return {
      form: {
        amountType: { required },
        percent: {
          required: requiredIf((model) => {
            return this.form.amountType === 'Percent'
          })
        },
        amount: {
          required: requiredIf((model) => {
            return this.form.amountType === 'Amount'
          })
        }
      }
    }
  },
  created () {
    this.form = { ...this.discount }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const data = {
          amountType: this.form.amountType,
          percent: this.form.amountType === 'Percent' ? this.form.percent : null,
          amount: this.form.amountType === 'Amount' ? this.form.amount : null
        }
        this.$emit('form:submit', data)
      }
    },
    cancel () {
      this.$emit('form:cancel')
    },
    getAmountTypesOptions () {
      return AmountTypes.map(itm => ({ value: itm, text: this.$t(`views.vouchers.discounts.amounttypes.${itm.toLowerCase()}`) }))
    },
    showAmountTypeInput (amountType) {
      return this.form.amountType === amountType
    }
  }
}
</script>

<style lang="scss">
$formular-max-width: 550px !default;

$formular-actions-gap: $spacer !default;
$formular-actions-button-gap: $spacer * 0.125 !default;

$formular-controls-input-inline-min-width: auto !default;
$formular-controls-textarea-inline-min-width: 280px !default;
$formular-controls-select-inline-min-width: auto !default;

.formluar {
  .form-actions {
    margin-top: $formular-actions-gap;

    > div {
      display: flex;
      align-items: center;
      margin: $formular-actions-button-gap * - 1;

      .btn {
        margin: $formular-actions-button-gap;
      }
    }
  }

  &.is-inline {
    max-width: 100%;

    .form-controls {
      .control-input {
        min-width: $formular-controls-input-inline-min-width;
      }

      .control-textarea {
        min-width: $formular-controls-textarea-inline-min-width;
      }

      .control-select {
        min-width: $formular-controls-select-inline-min-width;
      }
    }

    .form-actions {
      margin-top: 0;
    }
  }

  &.max-width {
    max-width: $formular-max-width;
  }
}
</style>
